import React, { useState, useEffect } from 'react'
import classnames from 'classnames'
import { filterDataAttr } from 'common/utils/attributes'

import './TextInput.scss'

const TextInput = ({
    label = '',
    value,
    onUpdate,
    controlType = 'text',
    errorMessages = [],
    placeholder = '',
    isRequired,
    isDisabled,
    isFocused,
    isReadOnly = false,
    isClickable = false,
    description = '',
    onClick = () => {},
    fullWide = false,
    ...rest
}) => {
    const [_value, _setValue] = useState(value)

    useEffect(() => {
        _setValue(value)
    }, [value])

    const onChange = evt => {
        if (!isDisabled) {
            _setValue(evt.target.value)
            try {
                onUpdate(evt.target.value)
            } catch (err) {
                console.error(err)
            }
        }
    }

    return (
        <div
            className={classnames('common-text-input', {
                'common-text-input__disabled': isDisabled,
                'full-wide': fullWide,
            })}
        >
            {label.length ? (
                <p
                    className={`common-text-input__label ${isRequired ? 'common-text-input__required' : ''}`}
                    data-optional={description}
                    title={label}
                >
                    {label}
                </p>
            ) : null}
            <input
                disabled={isDisabled}
                readOnly={isReadOnly}
                placeholder={placeholder}
                className={classnames('common-text-input__input-text', {
                    'is-error': !!errorMessages.length,
                    'is-focused': isFocused,
                    'is-clickable': isClickable,
                })}
                type={controlType}
                value={_value}
                title={_value}
                onChange={onChange}
                onClick={onClick}
                {...filterDataAttr(rest)}
            />
            {errorMessages.length
                ? errorMessages.map((message, i) => (
                      <p key={i} className="common-text-input__error">
                          {message}
                      </p>
                  ))
                : null}
        </div>
    )
}

export default TextInput
